import { AnimatePresence, motion } from "framer-motion";

import { Button } from "@virtual-brain-lib/frontend-design-system/ui";
import { cn, useIsOpen } from "@virtual-brain-lib/frontend-design-system/utils";
import type { MessageToolLinks } from "@virtual-brain-lib/types";

import { LinkRow } from "./LinkRow";
import { ToolCardAllLinksModal } from "./ToolCardAllLinksModal";

const MAX_VISIBLE = 5;

interface ToolCardLinkListProps {
	readonly links: MessageToolLinks["data"]["links"];
	readonly contentReferenceOffset?: number;
	readonly className?: string;
}

export function ToolCardLinkList({
	links,
	contentReferenceOffset,
	className,
}: ToolCardLinkListProps) {
	const modal = useIsOpen();

	if (links.length === 0) {
		return null;
	}

	const visible = links.length <= MAX_VISIBLE ? links : links.slice(0, MAX_VISIBLE);
	const hiddenCount = links.length - visible.length;

	return (
		<div className={cn("flex flex-col gap-2", className)}>
			<div className="flex flex-col">
				<AnimatePresence initial={false}>
					{visible.map((link) => (
						<motion.div
							key={link.id}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
							initial={{ opacity: 0 }}
							transition={{ duration: 0.2 }}
						>
							<LinkRow link={link} />
						</motion.div>
					))}
				</AnimatePresence>
			</div>

			{hiddenCount > 0 && (
				<Button
					classNames={{ wrapper: "-ml-1.5 self-start" }}
					color="secondary"
					size="xs"
					variant="ghost"
					onClick={modal.open}
				>
					Show all
				</Button>
			)}

			<ToolCardAllLinksModal
				close={modal.close}
				isOpen={modal.isOpen}
				links={links}
				contentReferenceOffset={contentReferenceOffset}
			/>
		</div>
	);
}
